import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-dashboard',
  templateUrl: './new-dashboard.component.html',
  styleUrls: ['./new-dashboard.component.css']
})
export class NewDashboardComponent implements OnInit {
  isExpanded = true; 

  constructor() {}

  ngOnInit() {}

  toggleAccordion() {
    this.isExpanded = !this.isExpanded; 
  }
}